import * as React from 'react';
function Compact(props) {
  return /*#__PURE__*/React.createElement('svg', Object.assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 17 16',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['nanqu-token-panel-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement('g', {
    id: "Compact-\u9875\u9762-1",
    stroke: 'none',
    strokeWidth: 1,
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/React.createElement('g', {
    id: "Compact-\u9ED8\u8BA4",
    transform: 'translate(-9.000000, -82.500000)',
    fill: 'currentColor',
    fillRule: 'nonzero'
  }, /*#__PURE__*/React.createElement('g', {
    id: "Compact-\u9009\u9879\u4E00",
    transform: 'translate(9.268811, 79.500000)'
  }, /*#__PURE__*/React.createElement('g', {
    id: 'Compact-smaller',
    transform: 'translate(0.000000, 3.000000)'
  }, /*#__PURE__*/React.createElement('rect', {
    id: "Compact-\u77E9\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement('path', {
    d: 'M10,14 L10,12 C10,10.8666667 10.8666667,10 12,10 L14,10 C14.4,10 14.6666667,10.2666667 14.6666667,10.6666667 C14.6666667,11.0666667 14.4,11.3333333 14,11.3333333 L12,11.3333333 C11.6,11.3333333 11.3333333,11.6 11.3333333,12 L11.3333333,14 C11.3333333,14.4 11.0666667,14.6666667 10.6666667,14.6666667 C10.2666667,14.6666667 10,14.4 10,14 L10,14 Z M4.66666667,14 L4.66666667,12 C4.66666667,11.6 4.4,11.3333333 4,11.3333333 L2,11.3333333 C1.6,11.3333333 1.33333333,11.0666667 1.33333333,10.6666667 C1.33333333,10.2666667 1.6,10 2,10 L4,10 C5.13333333,10 6,10.8666667 6,12 L6,14 C6,14.4 5.73333333,14.6666667 5.33333333,14.6666667 C4.93333333,14.6666667 4.66666666,14.4 4.66666667,14 L4.66666667,14 Z M12,6 C10.8666667,6 10,5.13333333 10,4 L10,2 C10,1.6 10.2666667,1.33333333 10.6666667,1.33333333 C11.0666667,1.33333333 11.3333333,1.6 11.3333333,2 L11.3333333,4 C11.3333333,4.4 11.6,4.66666667 12,4.66666667 L14,4.66666667 C14.4,4.66666667 14.6666667,4.93333334 14.6666667,5.33333333 C14.6666667,5.73333331 14.4,6 14,6 L12,6 L12,6 Z M2,6 C1.6,6 1.33333333,5.73333333 1.33333333,5.33333333 C1.33333333,4.93333333 1.6,4.66666666 2,4.66666667 L4,4.66666667 C4.4,4.66666667 4.66666667,4.4 4.66666667,4 L4.66666667,2 C4.66666667,1.6 4.93333334,1.33333333 5.33333333,1.33333333 C5.73333331,1.33333333 6,1.6 6,2 L6,4 C6,5.13333333 5.13333333,6 4,6 L2,6 Z',
    id: "Compact-\u5F62\u72B6"
  }))))));
}
export default Compact;